module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("484oO"))).then(() => parcelRequire('ikE14'));